"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignShortcutCommand = exports.AssignShortcutCommandOptions = void 0;
var tslib_1 = require("tslib");
var command_base_1 = require("../command-base");
var command_states_1 = require("../command-states");
var AssignShortcutCommandOptions = (function (_super) {
    tslib_1.__extends(AssignShortcutCommandOptions, _super);
    function AssignShortcutCommandOptions(control, keyCode, callback) {
        var _this = _super.call(this, control) || this;
        _this.keyCode = keyCode;
        _this.callback = callback;
        return _this;
    }
    return AssignShortcutCommandOptions;
}(command_base_1.CommandOptions));
exports.AssignShortcutCommandOptions = AssignShortcutCommandOptions;
var AssignShortcutCommand = (function (_super) {
    tslib_1.__extends(AssignShortcutCommand, _super);
    function AssignShortcutCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssignShortcutCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this);
    };
    AssignShortcutCommand.prototype.getState = function () {
        return new command_states_1.SimpleCommandState(this.isEnabled());
    };
    AssignShortcutCommand.prototype.isEnabledInReadOnlyMode = function () {
        return true;
    };
    AssignShortcutCommand.prototype.executeCore = function (_state, options) {
        this.control.shortcutManager.assignShortcut(options.keyCode, options.callback);
        return true;
    };
    return AssignShortcutCommand;
}(command_base_1.CommandBase));
exports.AssignShortcutCommand = AssignShortcutCommand;
